import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_LINKS_LIST,
  FETCH_LINKS_LIST_ERROR,
  CLEAR_FETCH_LINKS_LIST,
  APPLY_LINK_DRAG,
  APPLY_LINK_DRAG_ERROR,
  CLEAR_LINK_DRAG,
  ADD_LINK_SUCCESS,
  ADD_LINK_ERROR,
  CLEAR_ADD_LINK,
  DELETE_LINK_SUCCESS,
  DELETE_LINK_ERROR,
  CLEAR_DELETE_LINK,
  PATCH_LINK_SUCCESS,
  PATCH_LINK_ERROR,
  CLEAR_PATCH_LINK,
  FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_NETWORKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_LINKS_LIST,
  FETCH_SOCIAL_LINKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_LINKS_LIST,
  ADD_SOCIAL_LINK_SUCCESS,
  ADD_SOCIAL_LINK_ERROR,
  CLEAR_ADD_SOCIAL_LINK,
  DELETE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK_ERROR,
  CLEAR_DELETE_SOCIAL_LINK,
  PATCH_SOCIAL_LINK_SUCCESS,
  PATCH_SOCIAL_LINK_ERROR,
  CLEAR_PATCH_SOCIAL_LINK,
  SET_SOCIAL_LINKS_BUTTONS_MODE_SUCCESS,
  SET_SOCIAL_LINKS_BUTTONS_MODE_ERROR,
  CLEAR_SET_SOCIAL_LINKS_BUTTONS_MODE,
  REQUEST_SOCIAL_LINK_STATUS_SUCCESS,
  REQUEST_SOCIAL_LINK_STATUS_ERROR,
  CLEAR_REQUEST_SOCIAL_LINK_STATUS,
  FETCH_MOBILE_APPS_LINKS_LIST,
  FETCH_MOBILE_APPS_LINKS_LIST_ERROR,
  CLEAR_FETCH_MOBILE_APPS_LINKS_LIST,
  ADD_MOBILE_APPS_LINK_SUCCESS,
  ADD_MOBILE_APPS_LINK_ERROR,
  CLEAR_ADD_MOBILE_APPS_LINK,
  PATCH_MOBILE_APPS_LINK_SUCCESS,
  PATCH_MOBILE_APPS_LINK_ERROR,
  CLEAR_PATCH_MOBILE_APPS_LINK,
  DELETE_MOBILE_APPS_LINK_SUCCESS,
  DELETE_MOBILE_APPS_LINK_ERROR,
  CLEAR_DELETE_MOBILE_APPS_LINK,
  APPLY_MOBILE_APPS_LINK_DRAG_SUCCESS,
  APPLY_MOBILE_APPS_LINK_DRAG_ERROR,
  CLEAR_MOBILE_APPS_LINK_DRAG,
} from 'redux/links/types';


export const fetchLinksList = () => baseErrorsHandlerDecorator(
  FETCH_LINKS_LIST,
  FETCH_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/')),
  false,
);

export const clearLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_LINKS_LIST,
  });
};

export const applyLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_LINK_DRAG,
  APPLY_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_LINK_DRAG,
  });
};

export const addLink = (url, isHeader=false) => baseErrorsHandlerDecorator(
  ADD_LINK_SUCCESS,
  ADD_LINK_ERROR,
  () => restapi.post(addLang('links/'), { url, 'is_header': isHeader }),
  false,
  true /* actionSuccess */,
);

export const clearAddLink = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_LINK,
  });
};

export const deleteLink = linkId => baseErrorsHandlerDecorator(
  DELETE_LINK_SUCCESS,
  DELETE_LINK_ERROR,
  () => restapi.delete(addLang(`links/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_LINK,
  });
};

export const patchLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_LINK_SUCCESS,
  PATCH_LINK_ERROR,
  () => restapi.patch(addLang(`links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_LINK,
  });
};

// SOCIAL LINKS
export const fetchSocialNetworksList = () => baseErrorsHandlerDecorator(
  FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_NETWORKS_LIST_ERROR,
  () => restapi.get(addLang('links/social_links/social_networks/')),
  false,
);

export const clearFetchSocialNetworksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_SOCIAL_NETWORKS_LIST,
  });
};

// SOCIAL LINKS
export const fetchSocialLinksList = () => baseErrorsHandlerDecorator(
  FETCH_SOCIAL_LINKS_LIST,
  FETCH_SOCIAL_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/social_links/')),
  false,
);

export const clearFetchSocialLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_SOCIAL_LINKS_LIST,
  });
};

export const addSocialLink = formData => baseErrorsHandlerDecorator(
  ADD_SOCIAL_LINK_SUCCESS,
  ADD_SOCIAL_LINK_ERROR,
  () => restapi.post(addLang('links/social_links/'), formData),
  false,
  true /* actionSucces */,
);

export const clearAddSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_SOCIAL_LINK,
  });
};

export const deleteSocialLink = linkId => baseErrorsHandlerDecorator(
  DELETE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK_ERROR,
  () => restapi.delete(addLang(`links/social_links/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_SOCIAL_LINK,
  });
};

export const patchSocialLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_SOCIAL_LINK_SUCCESS,
  PATCH_SOCIAL_LINK_ERROR,
  () => restapi.patch(addLang(`links/social_links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_SOCIAL_LINK,
  });
};

export const setSocialLinksButtonsMode = mode => baseErrorsHandlerDecorator(
  SET_SOCIAL_LINKS_BUTTONS_MODE_SUCCESS,
  SET_SOCIAL_LINKS_BUTTONS_MODE_ERROR,
  () => restapi.post(addLang(`links/social_links/to_${mode}/`)),
  false,
  true /* actionSucces */,
);

export const clearSetSocialLinksButtonsMode = () => dispatch => {
  dispatch({
    type: CLEAR_SET_SOCIAL_LINKS_BUTTONS_MODE,
  });
};

// Request Social Link
export const requestSocialLink = url => baseErrorsHandlerDecorator(
  REQUEST_SOCIAL_LINK_STATUS_SUCCESS,
  REQUEST_SOCIAL_LINK_STATUS_ERROR,
  () => restapi.post(addLang('links/social_links/request/'), { url }),
  false,
  true, /* actionSucces */
);

export const clearRequestSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_REQUEST_SOCIAL_LINK_STATUS,
  });
};

export const fetchMobileAppsLinksList = () => baseErrorsHandlerDecorator(
  FETCH_MOBILE_APPS_LINKS_LIST,
  FETCH_MOBILE_APPS_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/app_links/')),
  false,
);

export const clearFetchMobileAppsLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_MOBILE_APPS_LINKS_LIST,
  });
};

export const addMobileAppsLink = (appType, url) => baseErrorsHandlerDecorator(
  ADD_MOBILE_APPS_LINK_SUCCESS,
  ADD_MOBILE_APPS_LINK_ERROR,
  () => restapi.post(addLang('links/app_links/'), {
    app_type: appType,
    url,
  }),
  false,
  true /* actionSucces */,
);

export const clearAddMobileAppsLink = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_MOBILE_APPS_LINK,
  });
};

export const patchMobileAppsLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_MOBILE_APPS_LINK_SUCCESS,
  PATCH_MOBILE_APPS_LINK_ERROR,
  () => restapi.patch(addLang(`links/app_links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchMobileAppsLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_MOBILE_APPS_LINK,
  });
};

export const deleteMobileAppsLink = linkId => baseErrorsHandlerDecorator(
  DELETE_MOBILE_APPS_LINK_SUCCESS,
  DELETE_MOBILE_APPS_LINK_ERROR,
  () => restapi.delete(addLang(`links/app_links/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteMobileAppsLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_MOBILE_APPS_LINK,
  });
};

export const applyMobileAppsLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_MOBILE_APPS_LINK_DRAG_SUCCESS,
  APPLY_MOBILE_APPS_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/app_links/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearMobileAppsLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_MOBILE_APPS_LINK_DRAG,
  });
};
